var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.collides)?_c('w2p-portal',{attrs:{"to":"notifications"}},[_c('out-of-boundaries-notification',{staticClass:"out-of-boundaries-notification",attrs:{"collision-data":_vm.collides}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }